import { useQuery } from '@tanstack/react-query';
import { fetchStoreCustomDomain } from './request';
import { STORE_CUSTOM_DOMAIN_QUERY_KEY } from './key';

export const useStoreCustomDomain = (enabled = true) => {
  return useQuery({
    queryKey: [STORE_CUSTOM_DOMAIN_QUERY_KEY],
    queryFn: fetchStoreCustomDomain,
    enabled,
    retry: false,
  });
};
